export const ALT_TEXT_PROMO_PLACEHOLDER =
  'Site message promoting offers, news, or updates';

const NORMALIZED_PROMO_PLACEHOLDER = ALT_TEXT_PROMO_PLACEHOLDER.toLowerCase();

const normalizeAltText = (value?: string): string =>
  value?.trim().toLowerCase() ?? '';

const hasMeaningfulAltText = (alt?: string): boolean => {
  const normalizedAlt = normalizeAltText(alt);
  return (
    Boolean(normalizedAlt) && normalizedAlt !== NORMALIZED_PROMO_PLACEHOLDER
  );
};

export const shouldReportMissingAlt = (alt?: string): boolean =>
  !hasMeaningfulAltText(alt);
